import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import querystring from 'query-string';

export default function orderCalculate(params) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, clearMessages, langId, additionalHeaders = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of orderCalculate()');
    invariant(brandId, 'brandId is a required param of orderCalculate()');
    invariant(country, 'country is a required param of orderCalculate()');
    invariant(uberToken, 'uberToken is a required param of orderCalculate()');
    invariant(clientId, 'clientId is a required param of orderCalculate()');

    const query = querystring.stringify({ langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/calculate${query ? `?${query}` : ''}`;
    const body = JSON.stringify({ clearMessages: clearMessages ? 'true' : undefined });
    const headers = { ...additionalHeaders };

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body }), uberToken, clientId, clientSecret),
        'orderCalculate',
    );
}
